import { useEffect, useState } from "react";
import jwt from "jsonwebtoken";
import moment from "moment";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import {
  attendanceTypeArray,
  leaveTypeListForEmail,
  numberToTextNumber,
} from "./utilities";
import Swal from "sweetalert2";
export const getOidcStorageKey = () => {
  const authSettings = JSON.parse(localStorage?.getItem("authSettings"));
  if (authSettings) {
    return `oidc.user:${authSettings.auth_server}:${authSettings.client_id}`;
  }
  return null;
};

export const getOidcInfo = () => {
  const key = getOidcStorageKey();
  if (key) {
    const oidc = JSON.parse(localStorage?.getItem(key));
    return oidc;
  }
  return null;
};

export const getToken = () => {
  const oidc = getOidcInfo();
  if (oidc) {
    return oidc.id_token;
  }
  return null;
};
export const usePagination = (data, itemsPerPage) => {
  const [currentPage, setCurrentPage] = useState(1);
  const maxPage = Math.ceil(data?.length / itemsPerPage);

  function currentData() {
    const begin = (currentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    return data?.slice(begin, end);
  }

  function next() {
    setCurrentPage((currentPage) => Math.min(currentPage + 1, maxPage));
  }

  function prev() {
    setCurrentPage((currentPage) => Math.max(currentPage - 1, 1));
  }

  function jump(page) {
    const pageNumber = Math.max(1, page);
    setCurrentPage((currentPage) => Math.min(pageNumber, maxPage));
  }

  return { next, prev, jump, currentData, currentPage, maxPage };
};

// weekend date finder
export const IsThereWeekend = (startDate, endDate) => {
  // date format: new Date("2022-03-01");
  let weekendDates = [];
  const initialState = startDate;
  initialState?.setDate(startDate?.getDate() + 1);
  for (
    let date = initialState;
    date < endDate;
    date.setDate(date.getDate() + 1)
  ) {
    if (date.getDay() < 5) {
      weekendDates.push(new Date(date.toString()));
    }
  }
  return weekendDates;
};

// leave policy weekend

export const IsThereWeekendwithLeavePolicy = (
  startDate,
  endDate,
  leaveTypeValue
) => {
  const start = moment(startDate);
  const end = moment(endDate);
  const actualLength = end.diff(start, "days") + 1;

  const daysSelected = [];
  for (let m = start.clone(); m.isSameOrBefore(end); m.add(1, "days")) {
    daysSelected.push(m.day());
  }

  const hasMonday = daysSelected.includes(1);
  const hasTuesday = daysSelected.includes(2);
  const hasWednesday = daysSelected.includes(3);
  const hasThursday = daysSelected.includes(4);
  const hasFriday = daysSelected.includes(5);
  const hasSaturday = daysSelected.includes(6);
  const hasSunday = daysSelected.includes(0);

  let deductedDays = actualLength;

  if ([1, 3].includes(leaveTypeValue)) {
    // Casual and Sick Leave
    if (
      hasMonday &&
      hasTuesday &&
      hasWednesday &&
      hasThursday &&
      hasFriday &&
      hasSaturday &&
      hasSunday
    ) {
      deductedDays = actualLength; // Deduct all days
    } else if (
      hasMonday &&
      hasTuesday &&
      hasWednesday &&
      hasThursday &&
      hasFriday &&
      hasSaturday
    ) {
      deductedDays = actualLength - 2; // Do not count Friday and Saturday
    } else if (hasThursday && hasSunday) {
      deductedDays = actualLength; // Deduct Friday and Saturday
    } else if (hasThursday) {
      deductedDays = actualLength; // Do not add Friday and Saturday
    } else if (hasSunday && hasFriday) {
      deductedDays = actualLength - 1; // Deduct only Sunday if Friday is included
    } else if (hasSunday) {
      deductedDays = actualLength; // Only count selected days
    }
  } else {
    // Annual and Other Leave
    if (
      hasMonday &&
      hasTuesday &&
      hasWednesday &&
      hasThursday &&
      hasFriday &&
      hasSaturday &&
      hasSunday
    ) {
      deductedDays = actualLength; // Deduct all days
    } else if (
      hasMonday &&
      hasTuesday &&
      hasWednesday &&
      hasThursday &&
      hasFriday &&
      hasSaturday
    ) {
      deductedDays = actualLength - 1; // Deduct Monday to Friday, exclude Saturday
    } else if (hasThursday && hasSunday) {
      deductedDays = actualLength; // Deduct Friday and Saturday
    } else if (hasThursday) {
      deductedDays = actualLength; // Do not add Friday
    } else if (hasSunday && hasFriday) {
      deductedDays = actualLength + 1; // Deduct Saturday and Sunday
    } else if (hasSunday) {
      deductedDays = actualLength + 1; // Deduct Saturday and Sunday
    }
  }

  return deductedDays;
};

export const isWeekendIncluded = (startDateStr, endDateStr) => {
  // Convert the string dates into Date objects
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  let includesFriday = false;
  let includesSaturday = false;

  // Loop through all dates from startDate to endDate
  for (
    let date = new Date(startDate);
    date <= endDate;
    date.setDate(date.getDate() + 1)
  ) {
    const dayOfWeek = date.getDay();
    if (dayOfWeek === 5) includesFriday = true; // Friday (5)
    if (dayOfWeek === 6) includesSaturday = true; // Saturday (6)
  }

  return includesFriday && includesSaturday;
};

// without weekend date

export const withoutWeekendDates = (startDate, endDate) => {
  // date format: new Date("2022-03-01");
  let weekendDates = [];
  const initialState = startDate;
  initialState?.setDate(startDate?.getDate());
  for (
    let date = initialState;
    date <= endDate;
    date.setDate(date.getDate() + 1)
  ) {
    if (date.getDay() < 5) {
      weekendDates.push(moment(new Date(date.toString())).format("YYYY-MM-DD"));
    }
  }
  return weekendDates;
};

// token decoder
export const customerInfo = () => {
  let info;
  const token = localStorage?.getItem("token");
  // jwt.verify(token, "test", function (err, decoded) {
  //   if (err) {
  //     localStorage.removeItem("token");
  //   }
  //   info = decoded;
  // });
  try {
    const decoded = jwtDecode(token);

    // Optional: Check for token expiry
    const isExpired = decoded.exp * 1000 < Date.now();

    if (isExpired) {
      localStorage.removeItem("token");
    } else {
      info = decoded;
    }
  } catch (err) {
    // Invalid token format
    localStorage.removeItem("token");
  }
  return info;
};
// token decoder
export const loginInfo = () => {
  let info;
  const token = localStorage?.getItem("token");
  // jwt.verify(token, "test", function (err, decoded) {
  //   if (err) {
  //     localStorage.removeItem("token");
  //   }
  //   info = decoded;
  // });
  try {
    const decoded = jwtDecode(token);

    // Optional: Check for token expiry
    const isExpired = decoded.exp * 1000 < Date.now();

    if (isExpired) {
      localStorage.removeItem("token");
    } else {
      info = decoded;
    }
  } catch (err) {
    // Invalid token format
    localStorage.removeItem("token");
  }
  return info;
};

// custom table index in new array
export const arrayCustomIndexing = (array) => {
  if (array?.length) {
    return array?.map((item, index) => ({
      ...item,
      tableIndex: index + 1,
    }));
  }
};

// text shortend by words with coustom lenght
export const textToWords = (text, length) => {
  return `${text
    ?.split(" ")
    ?.slice(0, length ? length : 5)
    ?.join(" ")}...`;
};

// check box json strigify value retirved
export const checkBoxValueRetrive = (value) => {
  let array = [];
  value &&
    JSON.parse(value).map((item) => {
      Object.keys(item).some(function (k) {
        if (item[k] === true) {
          array.push(k);
        }
      });
    });
  return array;
};

// remove duplicate year
export const removeDuplicateYear = (arrayOfYears) => {
  const yearDesc = arrayOfYears?.sort(function (a, b) {
    return b - a;
  });
  return [...new Set(yearDesc)];
};

// get all user attendance
export const userAttendenceObject = (item, index) => ({
  indexId: index + 1,
  attendance: item?.attendanceInfo?.length ? true : false,
  attendanceInfo: item?.attendanceInfo[0],
  employeeInfo: {
    designationInfo: {
      name: item?.additionalInfo?.designationInfo?.name,
    },
    user: {
      name: item?.name,
    },
    user_id: 18,
  },
  isAuthorized: item?.attendanceInfo[0]?.isAuthorized,
  id: item?.attendanceInfo[0]?.id,
  login_date: item?.attendanceInfo[0]?.login_date,
  login_device: item?.attendanceInfo[0]?.login_device,
  login_time: item?.attendanceInfo[0]?.login_time,
  logout_device: item?.attendanceInfo[0]?.logout_device,
  logout_time: item?.attendanceInfo[0]?.logout_time,
  reason: item?.attendanceInfo[0]?.reason,
  rfid: item?.additionalInfo?.rfid,
  type: item?.attendanceInfo[0]?.type,
  updatedAt: item?.attendanceInfo[0]?.updatedAt,
  user_ip: item?.attendanceInfo[0]?.user_ip,
  useragent: item?.attendanceInfo[0]?.useragent,
});

// checking penalty
export const penaltyChecking = async (
  checkStart,
  checkEnd,
  user_id,
  loadPenalty
) => {
  let penaltyDates = [];
  if (checkStart !== checkEnd) {
    const initialState = new Date(checkStart);
    initialState.setDate(new Date(checkStart).getDate());
    for (
      let date = initialState;
      date <= new Date(checkEnd);
      date.setDate(date.getDate() + 1)
    ) {
      const result = await loadPenalty?.refetch({
        user_id,
        penalty_date: moment(new Date(date.toString())).format("YYYY-MM-DD"),
      });
      if (
        result?.data?.getAllPenaltyByUserIdAndDate?.penalty_date &&
        result?.data?.getAllPenaltyByUserIdAndDate?.penalty_status == 1001
      ) {
        penaltyDates.push({
          id: result?.data?.getAllPenaltyByUserIdAndDate?.id,
          penalty_date:
            result?.data?.getAllPenaltyByUserIdAndDate?.penalty_date,
          penalty_status:
            result?.data?.getAllPenaltyByUserIdAndDate?.penalty_status,
        });
      }
    }
  } else {
    const result = await loadPenalty?.refetch({
      user_id,
      penalty_date: moment(new Date(checkStart)).format("YYYY-MM-DD"),
    });
    if (
      result?.data?.getAllPenaltyByUserIdAndDate?.penalty_date &&
      result?.data?.getAllPenaltyByUserIdAndDate?.penalty_status == 1001
    ) {
      penaltyDates.push({
        id: result?.data?.getAllPenaltyByUserIdAndDate?.id,
        penalty_date: result?.data?.getAllPenaltyByUserIdAndDate?.penalty_date,
        penalty_status:
          result?.data?.getAllPenaltyByUserIdAndDate?.penalty_status,
      });
    }
  }
  return penaltyDates;
};
// make date range array
export const dateRangeArray = (startDate, endDate) => {
  let arrayOfDates = [];
  if (startDate !== endDate) {
    const initialState = new Date(startDate);
    initialState.setDate(new Date(startDate).getDate());
    for (
      let date = initialState;
      date <= new Date(endDate);
      date.setDate(date.getDate() + 1)
    ) {
      arrayOfDates.push(moment(new Date(date.toString())).format("YYYY-MM-DD"));
    }
  } else {
    arrayOfDates.push(moment(new Date(startDate)).format("YYYY-MM-DD"));
  }
  return arrayOfDates;
};

// approval email template
export const approvalLeaveEmail = (html) => {
  return `
  <!DOCTYPE html>
  <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1">
    </head>
    <body>
      <p>Dear ${html?.applicant_name?.split(" ")[0]},</p>
      <p>Your application has been approved.</p>
      <p>Best Regards,</p>
      <p>${html?.approval_name}</p>
      <p>&mdash;</p>
      <p>On ${html?.leave_date} <i>${html?.applicant_name}&#60;${
    html?.applicant_email
  }&#62;</i> wrote:</p>
      <p>Start: ${html?.start_date}</p>
      <p>End: ${html?.end_date}</p>
      <p>Total: ${html?.total_day}</p>
      <p>The reason of leave: <br /> ${html?.leave_reason}</p>
    </body>
  </html>`;
};

export const checkWithDate = (array) => {
  // array format
  // const array = [
  //   {
  //     start_date: "2022-02-16",
  //     end_date: "2022-02-16",
  //     id: 1,
  //   }
  // ];
  const finalArray = [];
  const tempArray = array?.map((item) => {
    const startDate = moment(new Date(item?.start_date)).format("YYYY-MM-DD");
    const endDate = moment(new Date(item?.end_date)).format("YYYY-MM-DD");
    let arrayOfDates = [];
    if (startDate !== endDate) {
      const initialState = new Date(startDate);
      initialState.setDate(new Date(startDate).getDate());
      for (
        let date = initialState;
        date <= new Date(endDate);
        date.setDate(date.getDate() + 1)
      ) {
        arrayOfDates.push({
          application_date: moment(new Date(date.toString())).format(
            "YYYY-MM-DD"
          ),
          application_id: item?.id,
        });
      }
    } else {
      arrayOfDates.push({
        application_date: moment(new Date(startDate)).format("YYYY-MM-DD"),
        application_id: item?.id,
      });
    }
    return arrayOfDates;
  });

  tempArray?.map((item) => {
    item?.map((item2) => {
      finalArray.push(item2);
    });
  });
  return finalArray;
};

// exist leave or attendance application warning
export const isExistApllication = (existApplicationId, totalApplication) => {
  const existLeave = [];
  [...new Set(existApplicationId)]?.map((existId) => {
    totalApplication?.map((item) => {
      if (item?.id == existId) {
        existLeave.push({
          name:
            attendanceTypeArray?.find((type) => type?.value == item?.leave_type)
              ?.label ||
            leaveTypeListForEmail?.find(
              (type) => type?.value == item?.leave_type
            )?.label,
          status: item?.leave_status,
          start: moment(new Date(item?.start_date)).format("YYYY-MM-DD"),
          end: moment(new Date(item?.end_date)).format("YYYY-MM-DD"),
        });
      }
    });
  });
  Swal.fire(
    `Exist!`,
    `${numberToTextNumber[existLeave?.length]} ${
      existLeave?.length > 1 ? "applications" : "application"
    } already exist within your selected date. Try another date. <br/>
      <table style="border-collapse: collapse; margin: 0 auto; font-size: 10px; font-family: sans-serif; box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);">
          <thead>
              <tr style="background-color: #009879; color: #ffffff; text-align: left;">
                  <th style="padding: 12px 15px;">#</th>
                  <th style="padding: 12px 15px;">Applied For</th>
                  <th style="padding: 12px 15px;">Start</th>
                  <th style="padding: 12px 15px;">End</th>
                  <th style="padding: 12px 15px;">Day</th>
                  <th style="padding: 12px 15px;">Status</th>
              </tr>
          </thead>
          <tbody>
              ${
                existLeave?.length > 0
                  ? existLeave?.map(
                      (item, index) =>
                        `
          <tr style="border-bottom: 1px solid #dddddd;">
              <td style="padding: 12px 15px;">${index + 1}</td>
              <td style="padding: 12px 15px;">${item?.name}</td>
              <td style="padding: 12px 15px;">${moment(item?.start).format(
                "DD MMMM YYYY"
              )}</td>
              <td style="padding: 12px 15px;">${moment(item?.end).format(
                "DD MMMM YYYY"
              )}</td>
              <td style="padding: 12px 15px;">${
                withoutWeekendDates(
                  new Date(moment(item?.start).format("YYYY-MM-DD")),
                  new Date(moment(item?.end).format("YYYY-MM-DD"))
                )?.length
              } ${
                          withoutWeekendDates(
                            new Date(moment(item?.start).format("YYYY-MM-DD")),
                            new Date(moment(item?.end).format("YYYY-MM-DD"))
                          )?.length > 1
                            ? " Days"
                            : " Day"
                        }</td>
              <td style="padding: 12px 15px;">${item?.status}</td>
          </tr>      
        `
                    )
                  : null
              }
          </tbody>
      </table>`,
    "error"
  );
};

export function countWeekends(startDate, endDate) {
  // const startDate = new Date('2023-02-01');
  // const endDate = new Date('2023-02-28');
  // const weekends = countWeekends(startDate, endDate);
  let count = 0;
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    const dayOfWeek = currentDate.getDay();
    if (dayOfWeek === 5 || dayOfWeek === 6) {
      count++;
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return count;
}

export const dateFormat = (milliseconds, format) => {
  return milliseconds
    ? moment(new Date(Number(milliseconds))).format(
        format ?? "DD/MM/YY, hh:mm a"
      )
    : "-";
};

export const labelName = (array, id, label = "label") => {
  return array?.find((item) => item?.value == id)?.[label] ?? "-";
};

export const dateTime = (milliseconds, format) => {
  return milliseconds
    ? moment(new Date(Number(milliseconds))).format(
        format ?? "DD/MM/YY, hh:mm a"
      )
    : "-";
};

export const timeToMiliseconds = (time) => {
  const data = moment.duration(time).asMilliseconds();
  return data;
};

export const onlyTime = (h = 0, m = 0, s = 0) => {
  return `${h}h ${m}m ${s}s`;
};

export const pluralForm = (number = 0, string = "") =>
  `${number} ${string} ${number > 1 ? "s" : ""}`;

export const ageCalculator = (
  birth_date = new Date(),
  current_date = new Date()
) => {
  // Get the birthdate and current date
  const birthdate = moment(birth_date); // Replace with the actual birthdate and time in 'YYYY-MM-DDTHH:mm:ss' format
  const currentDate = moment(current_date);
  // Calculate the difference between birthdate and current date
  const duration = moment.duration(currentDate.diff(birthdate));

  // Extract years, months, days, hours, minutes, and seconds
  const years = duration.years();
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  return {
    years,
    months,
    days,
    hours,
    minutes,
    seconds,
  };
};

/** object to query params*/

//** image upload */
export const imageUpload = async (file, s3folderName) => {
  const imageData = new FormData();
  imageData.append("images", file);
  file = await axios.post(`${BASE_URL}/api/image/${s3folderName}`, imageData, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
  return file;
};

// ** image upload for multiple images
export const imagesUpload = async (files, s3folderName) => {
  const formData = new FormData();

  formData.append("folderName", s3folderName);
  for (const file of files) {
    formData.append("files", file);
  }

  const result = await axios.post(
    `${BASE_URL}/api/image/document-upload`,
    formData,
    {
      headers: {
        "content-type": "multipart/form-data",
      },
    }
  );

  return result;
};

export const deleteImage = async (image) => {
  await axios.post(
    `${BASE_URL}/api/image/image-delete`,
    { oldImage: image },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
// export const imagePreviewerUrl = (url, folderName) => {
//   // Check if the provided URL is hosted in an S3 bucket
//   const handleImage = checkS3Image(url);

//   // Check if the provided URL is base 64
//   const handleBase64Image = checkBase64(url);

//   /**
//    * Generate the preview link based on:
//    * 1. If the image is hosted in an S3 bucket with the full image URL
//    * 2. If the image is hosted in an S3 bucket with only the image name
//    * 3. If the image is hosted externally with the full image URL
//    * 4. If the image is not hosted (fallback to a default image preview)
//    */
//   const s3PreviewUrl = handleImage?.status
//     ? handleImage?.isPreviewAble
//       ? handleImage?.url
//       : getS3Img(handleImage?.filename, folderName)
//     : handleImage?.filename;

//   const previewUrl = handleBase64Image?.status
//     ? handleBase64Image?.base64String
//     : s3PreviewUrl;

//   return previewUrl;
// };

export const findOption = (array, id) => {
  return array?.find((item) => item?.value == id) || "";
};

// export const getDeductDays = (startDate, endDate, holidayList = []) => {
//   // 🔒 Step 0: Return 0 if either date is null or invalid
//   if (
//     !startDate ||
//     !endDate ||
//     isNaN(new Date(startDate)) ||
//     isNaN(new Date(endDate))
//   ) {
//     return 0;
//   }

//   let count = 0;
//   const current = new Date(startDate);

//   // Convert holidays to a Set of date strings for fast lookup
//   const holidaySet = new Set();
//   holidayList.forEach((h) => {
//     const from = new Date(h.start_date);
//     const to = new Date(h.end_date);
//     for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
//       holidaySet.add(moment(d).format("YYYY-MM-DD"));
//     }
//   });

//   while (current <= endDate) {
//     const day = current.getDay();
//     const dateStr = moment(current).format("YYYY-MM-DD");

//     // Exclude Friday (5), Saturday (6), and holidays
//     if (day !== 5 && day !== 6 && !holidaySet.has(dateStr)) {
//       count++;
//     }

//     current.setDate(current.getDate() + 1);
//   }

//   return count;
// };
export const getDeductDays = (
  startDate,
  endDate,
  holidayList = [],
  makeupDayList = []
) => {
  // 🔒 Validate inputs
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) {
    return 0;
  }

  let count = 0;
  const current = new Date(start);

  // 🏖️ Build holiday set
  const holidaySet = new Set();
  holidayList.forEach((h) => {
    const from = new Date(h.start_date);
    const to = new Date(h.end_date);
    for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
      holidaySet.add(moment(d).format("YYYY-MM-DD"));
    }
  });

  // 🗓️ Build makeup set
  const makeupSet = new Set();
  makeupDayList.forEach((m) => {
    const from = new Date(m.start_date);
    const to = new Date(m.end_date);
    for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
      makeupSet.add(moment(d).format("YYYY-MM-DD"));
    }
  });

  // 📆 Iterate through all dates from start to end
  while (current <= end) {
    const dayOfWeek = current.getDay(); // 0 = Sun ... 6 = Sat
    const dateStr = moment(current).format("YYYY-MM-DD");

    const isHoliday = holidaySet.has(dateStr);
    const isWeekend = dayOfWeek === 5 || dayOfWeek === 6;

    const isMakeup = makeupSet.has(dateStr);

    if ((!isHoliday && !isWeekend) || isMakeup) {
      count++;
    }

    current.setDate(current.getDate() + 1);
  }

  return count;
};

export const countThursdaysAndSundays = (startDate, endDate, holidays = []) => {
  if (!startDate || !endDate) {
    return {
      thursday: 0,
      sunday: 0,
      total: 0,
    };
  }

  const current = new Date(startDate);
  const end = new Date(endDate);

  let thursdayCount = 0;
  let sundayCount = 0;

  // Convert holidays into a Set of all holiday dates
  const holidaySet = new Set();
  holidays.forEach((h) => {
    const from = new Date(h.start_date);
    const to = new Date(h.end_date);
    for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
      holidaySet.add(moment(d).format("YYYY-MM-DD"));
    }
  });

  while (current <= end) {
    const day = current.getDay();
    const dateStr = moment(current).format("YYYY-MM-DD");

    if (!holidaySet.has(dateStr)) {
      if (day === 4) {
        thursdayCount++;
      } else if (day === 0) {
        sundayCount++;
      }
    }

    current.setDate(current.getDate() + 1);
  }

  return {
    thursday: thursdayCount,
    sunday: sundayCount,
    total: thursdayCount + sundayCount,
  };
};

export const calculateTotalDeduct = (
  startDate,
  endDate,
  holidays,
  leaveType,
  makeupDayList
) => {
  if (!startDate || !endDate) return 0;

  const result = getDeductDays(startDate, endDate, holidays, makeupDayList);
  const countDay = countThursdaysAndSundays(startDate, endDate, holidays);

  if (result === 0) {
    return 0;
  }

  if (countDay?.total !== undefined && leaveType !== undefined) {
    if (countDay.total > 1) {
      return result + countDay.total;
    } else if (countDay.total === 1 && leaveType?.value === 3) {
      return result;
    } else {
      return result + countDay.total;
    }
  }

  return 0;
};

export const calculateTotalDeductDays = ({
  startDate,
  endDate,
  holidays,
  leaveType,
}) => {
  const result = getDeductDays(startDate, endDate, holidays);
  const countDay = countThursdaysAndSundays(startDate, endDate, holidays);
  if (result === 0) {
    console.log("Result is zero, so no deduction.");
    return 0;
  }

  if (countDay && countDay.total !== undefined && leaveType !== undefined) {
    if (countDay.total > 1) {
      const total = result + countDay.total;
      console.log("Deduct all leave1:", total, "Result:", result);
      return total;
    } else if (countDay.total === 1 && leaveType === 3) {
      console.log("Deduct days only sick2:", result, "Result:", result);
      return result;
    } else {
      const total = result + countDay.total;
      console.log("Deduct days all3:", total, "Result:", result);
      return total;
    }
  }

  return result;
};

export async function getUserIP() {
  try {
    const response = await fetch("https://api64.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to fetch IP address:", error);
    return null;
  }
}

export const educationOptions = [
  { label: "No Formal Education", value: 0 },
  { label: "Pre-primary", value: 1 }, // e.g., play group, nursery
  { label: "Primary", value: 2 }, // Class 1–5
  { label: "Lower Secondary", value: 3 }, // Class 6–8
  { label: "Secondary (SSC)", value: 4 }, // Class 9–10
  { label: "Higher Secondary (HSC)", value: 5 }, // Class 11–12
  { label: "Diploma / Technical", value: 6 }, // Polytechnic or vocational
  { label: "Bachelor / Graduate", value: 7 }, // Honours / Pass
  { label: "Masters / Post Graduate", value: 8 }, // Master's degree
  { label: "Doctorate / PhD", value: 9 }, // PhD or equivalent
  { label: "Other", value: 10 },
];
export const degree = [
  { value: 1, label: "JSC (Junior School Certificate)" },
  { value: 2, label: "SSC (Secondary School Certificate)" },
  { value: 3, label: "HSC (Higher Secondary Certificate)" },
  { value: 4, label: "BSc (Bachelor of Science)" },
  { value: 5, label: "MSc (Master of Science)" },
  { value: 6, label: "BBA (Bachelor of Business Administration)" },
  { value: 7, label: "MBA (Master of Business Administration)" },
  { value: 8, label: "BA (Bachelor of Arts)" },
  { value: 9, label: "MA (Master of Arts)" },
  { value: 10, label: "LLB (Bachelor of Laws)" },
  { value: 11, label: "LLM (Master of Laws)" },
  { value: 12, label: "Diploma" },
  { value: 13, label: "PhD (Doctor of Philosophy)" },
  { value: 14, label: "MD (Doctor of Medicine)" },
  { value: 15, label: "MSc in Engineering" },
  { value: 16, label: "BSc in Engineering" },
];
export const formatDate = (value) => {
  if (!value) return "—";
  // try exact formats you expect from the API
  const m = moment(
    value,
    ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "YYYY/MM/DD HH:mm:ss"],
    true
  );
  return m.isValid() ? m.format("YYYY-MM-DD") : "—";
};

export const formatLoginTime = (s) => {
  if (!s) return "—";
  const clean = String(s)
    .trim()
    .replace(/\.\d+$/, ""); // drop microseconds
  const m = moment(
    clean,
    ["YYYY-M-D H:m:s", "YYYY-MM-DD HH:mm:ss", "H:m:s", "H:m"],
    true
  ); // strict
  return m.isValid() ? m.format("hh:mm:ss A") : "—";
};
export const filterObjectByValue = (obj) => {
  const filteredObject = {};
  for (let key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      obj[key] !== "" &&
      obj[key] !== undefined &&
      obj[key] !== null
    ) {
      filteredObject[key] = obj[key];
    }
  }
  return filteredObject;
};

/** object to query params*/
export const objectToQueryParams = (obj) => {
  const removeBlankValues = filterObjectByValue(obj);
  const searchParams = new URLSearchParams(removeBlankValues);
  const queryString = searchParams.toString();
  return queryString;
};

/** params to object */
export const paramsToObject = (params) => {
  const searchParams = new URLSearchParams(params);
  const paramsObject = Object.fromEntries(searchParams.entries());
  return paramsObject;
};
